import React, { useState } from 'react';
import { Elements, ExpressCheckoutElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useAct } from 'FlowTaker/store';

const ExpressButtons = ({
  amountInMinorUnits,
  onComplete,
  isMonthly,
  coverFee,
  stripePromise,
  returnUrl,
}) => {
  // Set up options for the Stripe Elements
  const elementsOptions = {
    mode: isMonthly ? 'subscription' : 'payment',
    amount: amountInMinorUnits,
    currency: 'gbp',
    setupFutureUsage: 'off_session'
  };

  if (amountInMinorUnits === 0 || amountInMinorUnits === null) return null;

  return (
    <Elements stripe={stripePromise} options={elementsOptions}>
      <ExpressCheckoutContent
        amountInMinorUnits={amountInMinorUnits}
        onComplete={onComplete}
        isMonthly={isMonthly}
        coverFee={coverFee}
        returnUrl={returnUrl}
      />
    </Elements>
  );
};


const ExpressCheckoutContent = ({
  amountInMinorUnits,
  onComplete,
  isMonthly,
  coverFee,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const act = useAct()
  const stripe = useStripe();
  const elements = useElements();

  // Express Checkout specific options
  const checkoutOptions = {
    emailRequired: true,
    paymentMethods: {
      googlePay: 'auto',
      applePay: 'auto',
      paypal: 'auto'
    },
    buttonType: {
      applePay: 'donate',
      googlePay: 'donate',
      paypal: 'pay'
    },
    layout: {
      overflow: 'never'
    }
  };

  // This function handles the checkout flow using your existing controller
  const handleConfirm = async (event) => {
    console.log({ event })
    try {
      setLoading(true);
      setError(null);

      // Use your existing controller endpoint
      act.taker.createStripePaymentIntent({ amountInMinorUnits, isMonthly, coverFee })
      .then(async ({ data }) => {
        const { clientSecret, paymentIntentId } = data

        const { error: confirmError } = await stripe.confirmPayment(
          {
            elements,
            clientSecret,
            redirect: 'if_required',
            confirmParams: {
              return_url: window.location.origin + '/admin/billing/stripe/example'
            }
        });

        if (confirmError) {
          console.error('Payment failed:', confirmError);
          setError(confirmError.message);
        } else {
          // Payment succeeded
          onComplete({
            success: true,
            stripePaymentIntentId: paymentIntentId
          });
        }
      })
    } catch (error) {
      console.error('Error:', error);
      setError(error.message || 'An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="checkout-page">
      {error && (
        <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>
          {error}
        </div>
      )}
      <ExpressCheckoutElement
        onConfirm={handleConfirm}
        options={checkoutOptions}
      />
      {loading && <div className="loading">Processing payment...</div>}
    </div>
  );
};

export default ExpressButtons;
